














































import { Vue, Component, Prop } from 'vue-property-decorator';

import BaseModal from '~/components/modals/BaseModal.vue';
import RateSelector from '~/components/partials/RateSelector.vue';
import AreaInput from '~/components/inputs/AreaInput.vue';

@Component({
  components: { BaseModal, RateSelector, AreaInput },
})
export default class WriteReviewModal extends Vue {
  @Prop(String) title: '{ No title }';

  selectedStars: number = 0;
  textContent: string = '';

  questions: Array<{name: string, note: number}> = [
    {
      name: 'Would you recommend this course to your friends?',
      note: 0,
    },
    {
      name: 'What do you think of the guidance?',
      note: 0,
    },
    {
      name: 'How did you find the description',
      note: 0,
    },
  ];

  /* Handle the disabled status of the submit button based on user answers */
  get disabledStatus () {
    const hasGivenAllNotes: boolean = this.questions.every((q: any) => q.note > 0);

    if (hasGivenAllNotes) return false;
    return true;
  }
};
